export default function MobileWarning() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Card */}
        <div className="bg-white rounded-2xl shadow-lg p-8 text-center space-y-6">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="w-20 h-20 rounded-full bg-blue-50 flex items-center justify-center">
              <svg
                className="w-10 h-10 text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </div>
          </div>

          {/* Title */}
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-slate-900">
              请使用电脑访问
            </h1>
            <p className="text-slate-600 leading-relaxed">
              为了获得最佳使用体验，本系统需要在电脑端访问
            </p>
          </div>

          {/* Footer */}
          <div className="pt-4 border-t border-slate-200">
            <p className="text-xs text-slate-500">
              推荐使用 Chrome、Safari、Edge 等现代浏览器
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
